module.exports = __webpack_public_path__ + "img/wingDRiderLogo@2x.53e35a98.png";